export class GetCollections {
    constructor() {
        this.getCollections = async () => {
            const apiUrl = process.env.REACT_APP_API_URL;
            try {
                const url = new URL(`/products/collections`, apiUrl);
                const response = await fetch(url.toString(), {
                    method: 'get',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                const data = await response.json();
                return data.custom_collections;
            }
            catch (error) {
                return console.error(error);
            }
        };
    }
}
